import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

Alpine.data('carouselModule', () => ({
  swiper: null,
  swiperWrapper: null,

  init() {
    this.swiper = new Swiper('.carousel-swiper', {
      modules: [Navigation],
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
      },
    });
  },
}));
